// @flow

import React, { memo } from 'react';
import Styles from './styles';

export default memo(() => (
  <Styles>
    <div className="blob blob-0" />
    <div className="blob blob-1" />
    <div className="blob blob-2" />
    <div className="blob blob-3" />
    <div className="blob blob-4" />
    <div className="blob blob-5" />
  </Styles>
));
